<template>
  <layout>
    <van-cell-group class="group" >
      <template v-if="$store.state.roleInfo.roleId !== '8'">
        <van-cell title="新增用户" to="/addCustomer?type=company" is-link />
        <van-cell title="未分配销售组用户" to="/unassignedUser" is-link />
        <van-cell title="收回销售组用户" to="/revokeSalesGroup" is-link />
      </template>
      <van-cell title="用户明细" to="/companyUser" is-link />
    </van-cell-group>
  </layout>>
</template>

<script>
export default {
  name: 'UserManagement',
  setup () {
    return {}
  }
}
</script>

<style lang="scss" scoped>

</style>
